//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import { loadingSet } from '../action/uiAction';
import * as partnerAction from '../action/partnerAction';
import * as bestpartnerAction from '../action/bestpartnerAction';
import * as lightboxAction from '../action/lightboxAction';
import * as helpAction from '../action/helpAction';
import * as favoriteAction from '../action/favoriteAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Chip from '@material-ui/core/Chip';
//Add
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { scroller, Element } from 'react-scroll';
//MenuItem
import MenuPartnerProfile from './MenuPartnerProfile';
//Part
import PartUserName from './PartUserName';
import PartPartnerProfile from './PartPartnerProfile';
import PartPartnerPost from './PartPartnerPost';
import PartPartnerQa from './PartPartnerQa';
import PartPartnerPersonality from './PartPartnerPersonality';
import PartStarIcon from './PartStarIcon';
import PartTimeIcon from './PartTimeIcon';
import PartCoupleIcon from './PartCoupleIcon';
import PartBreachCardIcon from './PartBreachCardIcon';
import PartPageTitle from './PartPageTitle';
//Dialog
import DialogMyPhotoMain from './DialogMyPhotoMain';
//Img
import NoimgMen from '../img/user/noimg_men.jpg';
import NoimgWomen from '../img/user/noimg_women.jpg';
import Blank from '../img/blank/blank-1x1.gif';
//Icon
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LockIcon from '@material-ui/icons/Lock';

class Comp extends React.Component {

  constructor(props) {
		super(props);

    this.state = {
      pic: props.match.params.pic,
      point: 0,
      profile: null,
      photo: [],
      setting: null,
      keyword: [],
      keywordCommon: [],
      favorite: null,
      postCount: 0,
      qaQuestionCount: 0,
      qaQuestionAnsweredCount: 0,
      qaAnswerCount: 0,
      couple: 0,
      favoriteDialogVisible: false,
      paymentTicketSendDialogVisible: false,
      tab: 'profile',
      datetime: null,
      errorComment: null,
      errorType: null,
      breachCard:null,

      mainPhotoDialog: false,
    }
	}

  componentDidMount() {
    this._partnerProfileGet(this.state.pic);
    window.scrollTo(0, 0);
    if (this.props.location.pathname.match(/^\/bestpartner\//)) {
      this.props.bestpartnerRead(this.state.pic);
    }
  }

  _partnerProfileGet(pic) {
    this.props.partnerProfileGet(pic, (data) => {
      this.setState({
        bool: data.bool,
        point: data.point,
				setting: data.setting,
				profile: data.profile,
				photo: data.photo,
				favorite: data.favorite,
        keyword: data.keyword,
        keywordCommon: data.keywordCommon,
        postCount: data.postCount,
        qaQuestionCount: data.qaQuestionCount,
        qaQuestionAnsweredCount: data.qaQuestionAnsweredCount,
        qaAnswerCount: data.qaAnswerCount,
        couple: data.couple,
        errorComment: data.errorComment,
        errorType: data.errorType,
        breachCard: data.breachCard,
        datetime: new Date(),
      })
    });
  }


  _renderImgMain(data) {
    let restriction = data.restriction;
    let img = null;

		if (data.uriCrop) {
			if (restriction === 1) {
				img = (
					<div style={{position:'relative'}}>
            <LazyLoadImage
              src={ data.uriCrop }
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
              alt=''
            />
            <div
              style={{
                position:'absolute',
                top:0,
                left:0,
                height:"100%",
                width: "100%",
                display: 'flex',
                justifyContent:'center',
                alignItems:'center',
                backgroundColor:'rgba(0, 0, 0, 0.5)'
              }}
            >
              <div>
  							<div

                  onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'メイン写真を公開している会員にだけ、メイン写真を公開する設定です。メイン写真が未掲載の会員にはボカシ加工のお写真が掲載されます。') }
                >
                  <div
                    style={{
                      display:'flex',
                      flexDirection:'row',
                      justifyContent:'center',
                      alignItems:'center',
                    }}
                  >
                    <LockIcon style={{fontSize:'1.6em', color:'#FFF', paddingRight:'5px'}}/>
                    <div style={{fontSize:'1.4em', fontWeight:'900', color:'#FFF'}}>公開制限</div>
                  </div>
                </div>
  							<div style={{fontSize:'0.9em', color:'#FFF'}}>あなたがメイン写真を掲載すると<br/>ボカシが解除されます</div>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={ () => this.setState({mainPhotoDialog: true}) }
                  style={{margin:'5px'}}
                >
                  <div style={{fontSize:'1.2em'}}>メイン写真を登録する</div>
                </Button>
              </div>
            </div>
					</div>
				)
			}
			else {
				img = (
          <div
            style={{cursor:'pointer',position:'relative'}}
            onClick={ () => this._lightboxOpen(data.uri) }
          >
            <LazyLoadImage
              src={ data.uriCrop }
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
              alt=''
            />
            <img
              src={Blank}
              style={{
                position:'absolute',
                left:0,
                top:0,
                width:'100%',
                height:'100%',
              }}
              alt=''
            />
          </div>
				)
			}
		}
		else {
      let uri;
      if (data.sex === 'men') {
        uri = NoimgMen;
      }
      else {
        uri = NoimgWomen;
      }
			img = (
        <LazyLoadImage
          src={ uri }
          style={{width:"100%", height: "auto", boxSizing:'border-box'}}
          placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
          alt=''
        />
			)
		}
    return (
      <div id='photo_main_outer'>
        { img }
      </div>
    )
	}

  _renderImgSub(value, index, arr) {
    let secret = value.secret;
    let img;

		if (secret === 1) {
			img = (
				<div
          style={{position:'relative'}}
        >
          <LazyLoadImage
            src={ value.uriCrop }
            style={{width:"100%", height: "auto", boxSizing:'border-box'}}
            placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
            alt=''
          />

					<div
            style={{
              position:'absolute',
              top:0,
              left:0,
              height:"100%",
              width: "100%",
              display: 'flex',
              justifyContent:'center',
              alignItems:'center',
              backgroundColor:'rgba(0, 0, 0, 0.5)'
            }}
          >
            <span
              className='button_white'
              onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'シークレット写真は「'+this.state.profile.userdata_name+'さん」が「あなた」をお気に入りに登録すると閲覧できます') }
            >
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                }}
              >
                <ExpandMoreIcon style={{fontSize:'0.8em'}} />
                <span style={{fontSize:'0.8em'}}>シークレット</span>
              </div>
            </span>
					</div>
				</div>
			)
		}
		else {
			img = (
				<div
          style={{cursor:'pointer',position:'relative'}}
          onClick={ () => this._lightboxOpen(value.uri) }
        >
          <LazyLoadImage
            src={ value.uriCrop }
            style={{width:"100%", height: "auto", boxSizing:'border-box'}}
            placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
            alt=''
          />

          <img
            src={Blank}
            style={{
              position:'absolute',
              left:0,
              top:0,
              width:'100%',
              height:'100%',
            }}
            alt=''
          />
				</div>
			)
		}

    return (
      <div
        key={index}
        className='box_outer'
      >
        <div
          className='box_inner round12'
        >
          { img }
        </div>
      </div>
    )
	}

  _lightboxOpen(selectUri) {
    let photoList = [];

    let partner = this.state;
    if (partner.photo.sub) {
      let subFilter = partner.photo.sub.filter(item => item.secret === 0);
      photoList = subFilter.map(function(value, index) {
        return {src: subFilter[index].uri};
      });
    }
    if (partner.photo.main.uri && partner.photo.main.restriction === 0) {
      photoList.unshift({src: partner.photo.main.uri});
    }
    let selectIndex = photoList.findIndex((v) => v.src === selectUri);
    this.props.lightboxOpen(photoList, selectIndex);

  }

  _tabChange(event, newValue) {
    this.setState({tab:newValue});
  }




  _qaQuestionAnsweredCountEdit(count) {
    let c = this.state.qaQuestionAnsweredCount + count;
    this.setState({qaQuestionAnsweredCount: c});
  }

  render() {

    if (this.state.datetime) {
      let partner = this.state;

      if (partner.bool === false) {
        return (
          <div>

            <div style={{margin:'30px'}}>
              <div style={{textAlign:'center'}}>
                <PartUserName
                  data={{
                    name: partner.profile.userdata_name,
                    sex: partner.profile.userdata_sex,
                    size: '1.2em',
                  }}
                />
              </div>

              {
                (partner.breachCard) && (
                  <div align='center' style={{margin:'10px'}}>
                    <PartBreachCardIcon breach={partner.breachCard} />
                  </div>
                )
              }

              <div
                align='center'
                style={{margin:'5px'}}
              >
                <h3>{partner.errorComment}</h3>
              </div>
              <div
                align='center'
                style={{margin:'5px'}}
              >
                {
                  (partner.errorType === 'myProfileComment') && (
                    <Button
                      color="primary"
                      variant={ "outlined" }
                      onClick={ () => this.props.history.push('/my/comment/') }
                    >
                      プロフィールのコメントを作成
                    </Button>
                  )
                }
                {
                  (partner.errorType === 'partnerStop' || partner.errorType === 'partnerOutage') && (
                    <div style={{margin:'10px'}}>

                      <Button
                        variant="outlined"
                        color="primary"
                        style={{fontSize:'1.1em'}}
                        startIcon={<MoreVertSharpIcon />}
                        onClick={ () => this.props.partnerOperationOpen(partner.profile.userdata_id_code, ['memo', 'nondisplay', 'refusal', 'breach']) }
                      >
                        設定
                      </Button>

                    </div>
                  )
                }

                <div style={{margin:'10px'}}>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{fontSize:'1em'}}
                    onClick={ () => this.props.helpOpen('id','410,411') }
                  >
                    停止、退会とはどのような状態？
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )
      }
      else {
        return (
          <div>
            <PartPageTitle
              title={(
                <PartUserName
                  data={{
                    name: partner.profile.userdata_name,
                    sex: partner.profile.userdata_sex,
                    size: '1.2em',
                  }}
                />
              )}
              onback={ '/search/' }
            />
            <div style={{textAlign:'center'}}>

              <div>
                <span style={{color:'#333', fontSize:'1.1em'}}>{partner.profile.userdata_age}才 {partner.profile.userdata_prof_region} {partner.profile.userdata_prof_region_detail}</span> <br/>
              </div>

              <PartBreachCardIcon breach={partner.breachCard} />

            </div>
            <div style={{margin:'15px 0px'}} align='center'>
              {
                (partner.couple === 1) && (
                  <PartCoupleIcon
                    mySex={this.props.my.profile.userdata_sex}
                    withMe={(this.props.my.profile.userdata_couple_code === this.state.pic) ? 1 : 0}
                  />
                )
              }

              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  flexWrap: 'wrap',
                  textAlign:'center',
                  alignItems:'center',
                  justifyContent:'center',
                  margin:'5px',
                }}
              >
                {
                  (partner.profile.userdata_proof_person === 1) && (
                    <span
                      className='proof_icon'
                      onClick={ (event) => this.props.popoverOpen(event.currentTarget, '公的な証明書のお名前、生年月日でご本人様であることが確認済です') }
                    >
                      本人証明
                    </span>
                  )
                }
                {
                  (partner.profile.userdata_proof_photo === 1) && (
                    <span
                      className='proof_icon'
                      onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'メイン写真がご本人様のお写真であることが確認済です') }
                    >
                      写真証明
                    </span>
                  )
                }
                {
                  (partner.profile.userdata_proof_income === 1) && (
                    <span
                      className='proof_icon'
                      onClick={ (event) => this.props.popoverOpen(event.currentTarget, '公的な書類でプロフィールの年収と昨年度の年収が一致していることが確認済です') }
                    >
                      収入証明
                    </span>
                  )
                }
                {
                  (partner.profile.userdata_proof_single === 1) && (
                    <span
                      className='proof_icon'
                      onClick={ (event) => this.props.popoverOpen(event.currentTarget, '公的な証明書で独身者であることが公的な証明書で確認済です') }
                    >
                      独身証明
                    </span>
                  )
                }
                {
                  (partner.profile.userdata_proof_credit === 1) && (
                    <span
                      className='proof_icon'
                      onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'カード会社の与信情報やカード名義が本人であることが確認済です') }
                    >
                      クレジット証明
                    </span>
                  )
                }
                <span
                  onClick={ () => this.props.helpOpen('category','loginTime') }
                >
                  <PartTimeIcon
                    text={partner.profile.userdata_login_aftertime}
                  />
                </span>

                <span
                  className='distance_icon'
                  onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'あなたのプロフィールの地域とお相手の地域の距離です。市郡区を表示しない設定でも市郡区から距離が計算されます。') }
                >
                  あなたとの距離{partner.profile.distance_word}
                </span>

                {
                  (partner.keywordCommon.length > 0) && (
                    <span
                      className='keywordCommon_icon'
                      onClick={ (event) => {
                        scroller.scrollTo('keyword_block', {
                          delay: 300,
                          duration: 300,
                          smooth: true,
                          offset: -50,
                        })
                      }}
                    >
                      共通するキーワード{partner.keywordCommon.length}つ
                    </span>
                  )
                }
              </div>
            </div>
            <div style={{textAlign:'center'}}>
              <div style={{display:'inline-block', position: 'relative', overflow:'hidden'}}>
                {
      						this._renderImgMain(partner.photo.main)
      					}
                {
                  (partner.profile.recent_singin === 1) && (
                    <div
                      className='ribbon_orange'
                      style={{position:'absolute', top:'0px', left:'0px'}}
                      onClick={ (event) => this.props.popoverOpen(event.currentTarget, '14日以内に入会した会員') }
                    >
                      NEW
                    </div>
                  )
                }

                <div style={{
                  position: 'absolute',
                  bottom:'20px',
                  left:'50%',
                  transform: 'translateX(-50%)',
                }}>
                  <div className='black_trans_icon'>
                    <div
                      style={{fontSize: '1em'}}
                      onClick={ (event) => this.props.popoverOpen(event.currentTarget, '希望条件とプロフィールとの一致している割合') }
                    >
                      プロフ相性 {partner.point.compatibility}%
                    </div>
                    {
                      (partner.point.character > 0) && (
                        <div
                          style={{fontSize: '1em'}}
                          onClick={ (event) => this.props.popoverOpen(event.currentTarget, '性格相性診断の結果') }
                        >
                          性格相性 <PartStarIcon count={partner.point.character} />
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
            <div align='center' style={{margin:'1px'}}>
              <div id={'photo_sub_block'}>
                {
      						(Array.isArray(partner.photo.sub) === true) &&
      						partner.photo.sub.map(
                    (value, index, arr) => this._renderImgSub(value, index, arr)
      						)
      					}
              </div>
            </div>
            {
              (partner.profile.userdata_prof_partner_comment) && (
                <div align='center' style={{margin:'15px'}}>
                  <Box
                    className='round12'
                    boxShadow={2}
                    style={{
                      display:'inline-block',
                      maxWidth:'400px',
                      margin:'auto',
                      padding:'10px',
                      background:'#fff',
                    }}>
                    <div style={{whiteSpace:'pre-line',textAlign:'left'}}>
                      {partner.profile.userdata_prof_partner_comment}
                    </div>
                  </Box>
                </div>
              )
            }

            <div style={{marginTop:'15px'}}>
              <Tabs
                value={this.state.tab}
                onChange={ (e, value) => this.setState({tab: value}) }
                indicatorColor="primary"
                centered
              >
                <Tab
                  value="profile"
                  label="プロフ"
                  style={{fontSize:'1.2em',fontWeight:'bold'}}
                />
                {
                  (partner.profile.post_count > 0) && (
                    <Tab
                      value="post"
                      label="投稿"
                      style={{fontSize:'1.2em',fontWeight:'bold'}}
                    />
                  )
                }
                {
                  (partner.profile.qa_question_count > 0 || partner.profile.qa_answer_count > 0 ) && (
                    <Tab
                      value="qa"
                      label="Q&A"
                      style={{fontSize:'1.2em',fontWeight:'bold'}}
                      wrapped
                    />
                  )
                }
                {
                  (partner.profile.character_diagnosis_check === 1) && (
                    <Tab
                      value='cha'
                      label="性格"
                      style={{fontSize:'1.2em',fontWeight:'bold'}}
                      wrapped
                    />
                  )
                }
              </Tabs>
            </div>
            <div>

              <div style={{borderTop:'1px solid #CCC'}}>
                {
                  (this.state.tab === 'profile') &&
                  <div className='profile_block'>
                    <div className='col2'>
                      <PartPartnerProfile
                        profile={partner.profile}
                      />
                    </div>

                    <div className='col2'>
                      <div align='center' style={{margin:'15px'}}>
                        <Box
                          className='round12'
                          boxShadow={2}
                          style={{
                            margin:'auto',
                            padding:'10px',
                            background:'#fff',
                            textAlign:'left',
                          }}
                        >
                          <h2 style={{textAlign:'center'}}>
                            自己紹介
                          </h2>
                          <div style={{whiteSpace:'pre-line'}}>
                            {partner.profile.userdata_prof_comment}
                          </div>
                        </Box>
                      </div>
                      {
                        (partner.keyword.length > 0 || partner.keywordCommon.length > 0) && (
                          <Element name='keyword_block'>
                            <div align='center' style={{margin:'15px'}}>
                              <Box
                                className='round12'
                                boxShadow={2}
                                style={{
                                  margin:'auto',
                                  padding:'10px',
                                  background:'#fff',
                                  textAlign:'left',
                                }}
                              >
                                {
                                  (partner.keywordCommon.length > 0) && (
                                    <>
                                      <h2 style={{textAlign:'center'}}>
                                        あなたと共通のキーワード
                                      </h2>
                                      <div>
                                        {
                                          partner.keywordCommon.map(
                                            (value, index, arr) => {
                                              return (
                                                <Chip
                                                  key={index}
                                                  label={ value }
                                                  variant="outlined"
                                                  color="secondary"
                                                  style={{margin:'3px'}}
                                                />
                                              )
                                            }
                                          )
                                        }
                                      </div>
                                    </>
                                  )
                                }
                                {
                                  (partner.keyword.length > 0) && (
                                    <>
                                      <h2 style={{textAlign:'center'}}>
                                        キーワード
                                      </h2>
                                      <div>
                                        {
                                          partner.keyword.map(
                                            (value, index, arr) => {
                                              return (
                                                <Chip
                                                  key={index}
                                                  label={ value }
                                                  variant="outlined"
                                                  style={{margin:'3px'}}
                                                />
                                              )
                                            }
                                          )
                                        }
                                      </div>
                                    </>
                                  )
                                }
                              </Box>
                            </div>
                          </Element>
                        )
                      }
                      {
                        (
                          partner.profile.userdata_want_proof_person === 1 ||
                          partner.profile.userdata_want_proof_photo === 1 ||
                          partner.profile.userdata_want_proof_income === 1 ||
                          partner.profile.userdata_want_proof_single === 1
                        ) && (
                          <div align='center' style={{margin:'15px'}}>
                            <Box
                              className='round12'
                              boxShadow={2}
                              style={{
                                margin:'auto',
                                padding:'10px',
                                background:'#fff',
                                textAlign:'left',
                              }}
                            >
                              <h2 style={{textAlign:'center'}}>
                                希望する証明書
                              </h2>
                              <div>
                                {
                                  (partner.profile.userdata_want_proof_person === 1) && (
                                    <span className='proof_icon'>本人証明</span>
                                  )
                                }
                                {
                                  (partner.profile.userdata_want_proof_photo === 1) && (
                                    <span className='proof_icon'>写真証明</span>
                                  )
                                }
                                {
                                  (partner.profile.userdata_want_proof_income === 1) && (
                                    <span className='proof_icon'>収入証明</span>
                                  )
                                }
                                {
                                  (partner.profile.userdata_want_proof_single === 1) && (
                                    <span className='proof_icon'>独身証明</span>
                                  )
                                }
                              </div>
                            </Box>
                          </div>
                        )
                      }
                    </div>
                    <div style={{clear:'both'}}></div>
                  </div>
                }
                {
                  (this.state.tab === 'post') && (
                    <div
                      className='post_block'
                      style={{maxWidth:'600px',margin:'auto',}}
                    >
                      <PartPartnerPost
                        pic={partner.profile.userdata_id_code}
                        postCount={partner.profile.post_count}
                      />
                    </div>
                  )
                }
                {
                  (this.state.tab === 'qa') && (
                    <div
                      className='qa_block'
                      style={{maxWidth:'600px',margin:'auto',}}
                    >
                      <PartPartnerQa
                        pic={partner.profile.userdata_id_code}
                        qaQuestionCount={partner.qaQuestionCount}
                        qaQuestionAnsweredCount={partner.qaQuestionAnsweredCount}
                        qaAnswerCount={partner.qaAnswerCount}
                        qaQuestionAnsweredCountEdit={ (count) => this._qaQuestionAnsweredCountEdit(count) }
                        tab={ (partner.qaQuestionCount > 0 ? 'question' : 'answer') }
                      />
                    </div>
                  )
                }
                {
                  (this.state.tab === 'cha') &&
                  <div
                    className='cha_block'
                    style={{maxWidth:'600px',margin:'auto',}}
                  >
                    <PartPartnerPersonality
                      pic={partner.profile.userdata_id_code}
                    />
                  </div>
                }

              </div>
            </div>
            <div style={{height:'60px',width:'100%'}}></div>

            <MenuPartnerProfile
              pic={this.state.pic}
              favorite={partner.favorite.my}
            />

            <DialogMyPhotoMain
              open={this.state.mainPhotoDialog}
              close={ () => this.setState({mainPhotoDialog: false}) }
            />
          </div>
        )
      }

    }
    else {
      return null;
    }
  }
}


const mapStateToProps = (state) => {
	return {
		notification: state.notification,
    my: state.my,
    partner: state.partner,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    loadingSet,
    ...partnerAction,
    ...favoriteAction,
    ...bestpartnerAction,
    ...lightboxAction,
    ...helpAction,
    ...partnerOperationAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
